import permissions from "../constants/permissions";
import ElixioPayModuleLayout from "@/views/Pages/ElixioPayModule/ElixioPayModuleLayout.vue";
import ElixioPayModuleMenu from "@/views/Pages/ElixioPayModule/ElixioPayModuleMenu.vue";

// import middleware
import authenticated from "@/middleware/authenticated";
import authorized from "@/middleware/authorized";

// import pages
/* const ListCustomerPage = () =>
  import(
    "@/views/Pages/ElixioPayModule/CustomerManagement/ListCustomerPage.vue"
  ); */

const ElixioPayListTransactionPage = () =>
  import(
    "@/views/Pages/ElixioPayModule/TransactionManagement/ListTransactionPage.vue"
  );

const ListNuveiCardPage = () =>
  import(
    "@/views/Pages/ElixioPayModule/NuveiCardManagement/ListNuveiCardPage.vue"
  );

const ElixioPayPage = () =>
  import("@/views/Pages/ElixioPayModule/ElixioPayPage.vue");

/* let customerManagementPages = {
  path: "customers",
  components: {
    default: ElixioPayModuleLayout,
    SidebarSecondLevelMenu: ElixioPayModuleMenu,
  },
  children: [
    {
      path: "",
      name: "List Customers",
      components: { default: ListCustomerPage },
      meta: {
        middleware: authorized,
        permission: permissions.PERM_VIEW_ANY_CUSTOMERS,
        hasLevel2: true,
      },
    },
  ],
}; */

let nuveiCardManagementPages = {
  path: "nuvei-cards",
  components: {
    default: ElixioPayModuleLayout,
    SidebarSecondLevelMenu: ElixioPayModuleMenu,
  },
  children: [
    {
      path: "",
      name: "List NuveiCards",
      components: { default: ListNuveiCardPage },
      meta: {
        middleware: authorized,
        permission: permissions.PERM_VIEW_ANY_NUVEI_CARDS,
        hasLevel2: true,
      },
    },
  ],
};

let transactionManagementPages = {
  path: "transactions",
  components: {
    default: ElixioPayModuleLayout,
    SidebarSecondLevelMenu: ElixioPayModuleMenu,
  },
  children: [
    {
      path: "",
      name: "List ElixioPayTransactions",
      components: { default: ElixioPayListTransactionPage },
      meta: {
        middleware: authorized,
        permission: permissions.PERM_VIEW_ANY_ELIXIOPAY_TRANSACTIONS,
        hasLevel2: true,
      },
    },
  ],
};

const elixioPayModuleRoutes = [
  {
    path: "",
    components: {
      default: ElixioPayModuleLayout,
      SidebarSecondLevelMenu: ElixioPayModuleMenu,
    },
    children: [
      {
        path: "",
        name: "ElixioPay Page",
        components: { default: ElixioPayPage },
        meta: {
          middleware: authenticated,
          hasLevel2: true,
        },
      },
    ],
  },
  //customerManagementPages,
  transactionManagementPages,
  nuveiCardManagementPages,
];

export default elixioPayModuleRoutes;
